export enum AdvertiserMenuItem {
  CAMPAIGNS = 'CAMPAIGNS',
  AUDIENCES = 'AUDIENCES',
  REPORTING = 'REPORTING',
  USER_ACCOUNTS = 'USER_ACCOUNTS',
  BILLING = 'BILLING',
  AUDIT_LOG = 'AUDIT_LOG',
}

export interface RawProjectApiResponse {
  id: string;
  project_key: string;
  company_name: string;
  logo_url?: string;
  terms_url?: string;
  privacy_url?: string;
  primary_color?: string;
  secondary_color?: string;
  advertiser_menu_items?: AdvertiserMenuItem[];
  attribution_window_days: number | null;
  kpis: ProjectSettingsKPIs;
  api: ProjectSettingsApiInfo;
  currency: string;
  /** Set by RMT; it cannot be changed through the API */
  ai_assistant_enabled?: boolean;
  custom?: any;
  created_at: string;
  updated_at: string;
}

export interface RawProjectSettingsApiResponse {
  project_key: string;
  company_name: string;
  organization_key: string;
  logo_url?: string;
  terms_url?: string;
  privacy_url?: string;
  primary_color?: string;
  secondary_color?: string;
  advertiser_menu_items?: AdvertiserMenuItem[];
  attribution_window_days: number | null;
  kpis?: ProjectSettingsKPIs;
  api?: ProjectSettingsApiInfo;
  currency: string;
  /** Set by RMT; it cannot be changed through the API */
  ai_assistant_enabled?: boolean;
  custom?: any;
  landing_page?: {
    background_color?: string;
    illustration_url?: string;
  };
  name_mapping?: {
    advertiser_key?: string | null;
  };
}

export enum AvailableRegions {
  EU = 'EU',
  US_EAST = 'US-EAST',
  BR = 'BR',
  AU = 'AU',
  JP = 'JP',
  UK = 'UK',
}

export interface ProjectSettingsApiInfo {
  region: AvailableRegions;
  url: string;
}

export enum ProjectSettingsAvailableKPIs {
  AD_REQUEST = 'ad-request',
  AD_REQUEST_WITH_ADS = 'ad-request-with-ads',
  ADD_TO_CART = 'add-to-cart',
  AVG_WIN_POSITION = 'avg-win-position',
  BILLED_PRICE = 'billed-price',
  CLICK = 'click',
  CONVERSION = 'conversion',
  CPC = 'cpc',
  CPM = 'cpm',
  CPO = 'cpo',
  CTR = 'ctr',
  FILL_RATE = 'fill-rate',
  IMPRESSION = 'impression',
  ORDER = 'order',
  REVENUE = 'revenue',
  REVENUE_WITH_ADS = 'revenue-with-ads',
  ONLINE_REVENUE_WITH_ADS = 'online-revenue-with-ads',
  OFFLINE_REVENUE_WITH_ADS = 'offline-revenue-with-ads',
  ROAS = 'roas',
  ONLINE_ROAS = 'online-roas',
  OFFLINE_ROAS = 'offline-roas',
  ADJUSTED_ROAS = 'adjusted-roas',
  ADJUSTED_ONLINE_ROAS = 'adjusted-online-roas',
  ADJUSTED_OFFLINE_ROAS = 'adjusted-offline-roas',
  SHOPPER = 'shopper',
  UNIT = 'unit',
  UNIT_WITH_ADS = 'unit-with-ads',
  VIDEO_COMPLETE = 'video-complete',
  VIDEO_START = 'video-start',
  WIN_RATE = 'win-rate',
}

export interface ProjectSettingsKPIs {
  retailer?: ProjectSettingsAvailableKPIs[] | null;
  advertiser?: ProjectSettingsAvailableKPIs[] | null;
}

export interface RawProjectSettingsPatchRequest {
  logo_url?: string;
  terms_url?: string;
  privacy_url?: string;
  primary_color?: string;
  secondary_color?: string;
  attribution_window_days?: number;
  kpis?: ProjectSettingsKPIs;
  currency?: string;
  custom?: any;
  advertiser_menu_items?: AdvertiserMenuItem[];
  landing_page?: {
    background_color?: string;
    illustration_url?: string;
  };
  name_mapping?: {
    advertiser_key?: string | null;
  };
}
